import script from "./TestIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./TestIntro.vue?vue&type=script&setup=true&lang=js"

import "./TestIntro.vue?vue&type=style&index=0&id=c26cb5aa&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c26cb5aa"]])

export default __exports__